import React from "react"
import { Col, Row } from "react-bootstrap"
import { DiJavascript1, DiReact, DiGit, DiHtml5, DiCss3, DiNodejs } from "react-icons/di"
import { SiFirebase, SiTypescript, SiRedux, SiVisualstudiocode, SiAdobexd, SiAdobephotoshop, SiExpress, SiMaterialdesign, SiAdobe, SiFigma } from "react-icons/si"
import { FaVuejs } from "react-icons/fa"
import { GrGatsbyjs } from "react-icons/gr"
import localization from "utils/localization"
import { TbLetterS } from "react-icons/tb"
import { MdCloudQueue } from 'react-icons/md'

const Techstack = () => (
    <>
        <h1 className="project-heading">
            { localization('my2') } <strong className="purple">{ localization('skills') } </strong> { localization('and') } <strong className="purple">{ localization('tools') }</strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
            <Col xs={4} md={2} className="tech-icons">
                <DiJavascript1 />
                <p className="tech-label">Javascript</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiTypescript />
                <p className="tech-label">Typescript</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <DiHtml5 />
                <p className="tech-label">HTML</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <DiCss3 />
                <p className="tech-label">CSS / SCSS</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <DiReact />
                <p className="tech-label">React / React Native</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiRedux />
                <p className="tech-label">Redux</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <GrGatsbyjs />
                <p className="tech-label">Gatsby</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <FaVuejs />
                <p className="tech-label">VueJS</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiMaterialdesign />
                <p className="tech-label">Material-UI / RN Paper</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiFirebase />
                <p className="tech-label">Firebase</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <DiNodejs />
                <p className="tech-label">Node</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiExpress />
                <p className="tech-label">Express</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <TbLetterS />
                <p className="tech-label">Sanity</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiAdobe />
                <p className="tech-label">Adobe Experience Manager</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <DiGit />
                <p className="tech-label">Git / Github</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiVisualstudiocode/>
                <p className="tech-label">VS Code</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiAdobexd/>
                <p className="tech-label">Adobe XD</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiFigma/>
                <p className="tech-label">Figma</p>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiAdobephotoshop/>
                <p className="tech-label">Adobe Photoshop</p>
            </Col>
        </Row>
    </>
)

export default Techstack
